export const meta: BlockMeta = {
  title: "Divider",
  tags: ["#page"],
}

import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/divider", (props) => {
  return (
    <div className="content-sized block-spacing">
      <div className="w-full h-[1px] bg-concrete relative" />
    </div>
  )
})
